import React, { FC } from 'react';

export const calculateTotal = (total, discount) => {
  let calculatedTotal = total;

  if (!discount) return calculatedTotal;

  if (discount.type == 'percent') {
    calculatedTotal = calculatedTotal * ((100 - discount.value) / 100);
  } else {
    calculatedTotal -= discount.value * 100;
  }

  return calculatedTotal;
};

const PaymentMode: FC<any> = ({ children, mode, selected }) => {
  return (
    <div className={`payment-mode d-flex flex-column ${selected ? 'selected' : ''}`}>
      {mode.discount && mode.discount.value > 0 && (
        <div className="discount">
          <div className="amount">{`-${mode.discount.value}${mode.discount.type == 'percent' ? '%' : '$'}`}</div>
        </div>
      )}

      {children}
    </div>
  );
};

export default PaymentMode;
